import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';
import Select from 'react-select';

function getErrors(myObject) {
    return Object.keys(myObject).map(function(key, index) {
        return <div key={index}>{myObject[key]}</div>
    });
}

export default (props) => {

    const {inputProps, onConfirm, onCancel, handlePrice, companies, currentOrder} = props;
    let {
        type,
        show,
        price,
        totalPrice,
        oldTotalPrice,
        oldPrice,
        commission,
        loading,
        error,
    } = inputProps;
    let title = 'Изменение цены заказа';

    if(type === 'success') title = 'Цена успешна изменена!';
    if(type === 'error') title = 'При изменении цены произошла ошибка!';

    let count = 0;
    let coutnText = 'Сумма к оплате: 0';

    if(parseFloat(price) !== 0 && parseFloat(oldTotalPrice) > parseFloat(totalPrice)){
        count = parseFloat(oldTotalPrice) - parseFloat(totalPrice);
        coutnText = <span>{`Сумма которая вернется на счёт: +${count}`}</span>;
    }

    else if(parseFloat(price) !== 0 && parseFloat(oldTotalPrice) < parseFloat(totalPrice)){
        count = parseFloat(totalPrice) - parseFloat(oldTotalPrice);
        coutnText = <span>{`Сумма к оплате: ${count}`}</span>;
    }

    return (
        <SweetAlert
            show={show}
            type={type}
            confirmBtnCssClass="alert-btn-confirm"
            cancelBtnCssClass="alert-btn-cancel"
            showCancel
            showConfirm={type === 'default' ? true : false}
            confirmBtnText="Отправить"
            cancelBtnText={type === 'default' ? "Отменить" : "Закрыть"}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={title}
            onConfirm={() => loading ? false : onConfirm()}
            onCancel={() => onCancel()}
        >
            {
                <div className="sw-alert__body">
                    {
                        type === 'default' ?
                        <div>
                            <label style={{display:'block'}}>Новая цена</label>
                            <input
                                type="number"
                                min="0"
                                style={{paddingLeft: '15px',borderRadius: '3px',border: '1px solid #ccc',fontSize: '14px',height: '38px',marginTop: '8px'}}
                                value={price}
                                onChange={(e) => handlePrice(e.target.value)}
                                />
                            <div>
                                <div>Комиссия: {commission}</div>
                                <div>{coutnText}</div>

                                <div style={{marginTop: '20px', borderTop: '1px solid #ccc', paddingTop:'10px'}}>Старая оплаченная сумма: {oldTotalPrice}</div>
                            </div>
                        </div>
                        :
                        type === 'success' ?
                        <div>{`Новая цена заказа: ${price} р.`}</div>
                        :
                        <div>
                            {getErrors(error)}
                        </div>
                    }
                </div> 
            }
        </SweetAlert>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Modals/ChangePrice.js